// extracted by mini-css-extract-plugin
export default {"root":"CreateOrder_root__KqrPJ","backBtn":"CreateOrder_backBtn__4cm-s","main":"CreateOrder_main__uHDXS","column":"CreateOrder_column__oLm-B"};